import { render, staticRenderFns } from "./editSlideshow.vue?vue&type=template&id=4ea587aa&scoped=true&"
import script from "./editSlideshow.vue?vue&type=script&lang=js&"
export * from "./editSlideshow.vue?vue&type=script&lang=js&"
import style0 from "./editSlideshow.vue?vue&type=style&index=0&id=4ea587aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea587aa",
  null
  
)

export default component.exports